export default function(n,t,r,u){return function(e,i){var o,a,c,f;return c=function m(d){return requestAnimationFrame(function(l){a||(a=l),o=l-a,f=Math.round(u(o,n,t-n,r)),(t>n?f<t&&d<=t:f>t&&d>=t)&&o<=r?(c=m(f),e(f)):(e(t),i&&i())})}(n),function(){cancelAnimationFrame(c)}}};
//# sourceMappingURL=tinkerbell.es.js.map
